export const BASE_URL = 'https://dummyjson.com/';